export default __webpack_public_path__ + "static/media/card7.4e76c05a.svg";